@if (isDetailsViewAvailable()) {
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onDetailClicked()"
    id="bookingOverviewDetailBtn"
    icon="search"
    size="small"></pas-button-round>
}
@if (isEditable()) {
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onEditClicked()"
    id="bookingOverviewEditBtn"
    icon="mode_edit"
    size="small"></pas-button-round>
}
